<script setup>

import {onMounted, ref} from 'vue';
import Button from "@/components/forms/Button.vue";
import {formatDate, showSuccessMessage} from '../../helper';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import {refreshLoggedUser} from '@/services/AuthService';
import ClientService from "@/services/ClientService";
import {useDataTable} from "@/utils/datatableHelper";
import ModalDialog from "@/components/modals/ModalDialog.vue";
import UpdateClientInvestmentsModal from "@/components/modals/UpdateClientInvestmentsModal.vue";

import {useI18n} from 'vue-i18n'

const {t} = useI18n()

const props = defineProps({
  entityId: {
    type: Number,
    default: null,
  },
});

const investments = ref([]);

const isLoading = ref(false);

const columns = ref([
  {
    label: t('investmentIndexTableComponent.strategy_name'),
    field: 'strategy.strategy_name',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('investmentIndexTableComponent.variable_symbol'),
    field: 'variable_symbol'
  },
  {
    label: t('investmentIndexTableComponent.name_by_client'),
    field: 'label_text'
  },
  {
    label: t('investmentIndexTableComponent.contract_type'),
    field: 'contract.contractType'
  },
  {
    label: t('investmentIndexTableComponent.contractNumber'),
    field: 'contract.contractNumber'
  },
  {
    label: '',
    field: 'action',
    sortable: false,
  },
]);

onMounted(async () => {
      getInvestments();
      emitter.on('investmentsSaved', () => {
          getInvestments();
      });
      emitter.on('investmentDeleted', (investmentId) => {
          let investmentIndex = investments.value.findIndex(investment => investment.id === investmentId);
          investments.value.splice(investmentIndex, 1);
      })
    }
);

function getInvestments() {
  isLoading.value = true;
  ClientService.getClientInvestments(props.entityId, true)
      .then((response) => {
          investments.value = response;
          isLoading.value = false;
      })
      .catch((error) => {
        console.log(error);
      });
}

function updateInvestment(investment) {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(UpdateClientInvestmentsModal, { clientId: props.entityId, investment: investment });
  reveal();
  onConfirm((investment) => {
    ClientService.saveInvestment(props.entityId, investment).then(response => {
      let investmentIndex = investments.value.findIndex(investment => investment.id === response.contract_strategy.id);
      investments.value[investmentIndex] = response.contract_strategy;
      showSuccessMessage(response.message);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div>

    <div class="table-container">
      <vue-good-table
          :columns="columns"
          :rows="investments"
          :pagination-options="{
              enabled: true,
              rowsPerPageLabel: t('investmentIndexTableComponent.entriesPerPage'),
              nextLabel: t('investmentIndexTableComponent.next'),
              prevLabel: t('investmentIndexTableComponent.previous'),
              ofLabel: 'z',
          }">
        <template #table-row="props">
              <span v-if="props.column.field == 'strategy.strategy_name'">
                <span :class="props.row.meta.is_trashed ? 'line-through' : ''">{{ props.row.strategy?.strategy_name }}</span>
                <div v-if="props.row.meta.is_trashed"><span class="badge badge-danger">Smazáno</span></div>
              </span>
                            <span v-if="props.column.field == 'action'">
                                <span style="font-weight: bold; float: right">
<!--                                    <router-link :to="{ name: 'ClientDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-link"><i class="mdi mdi-eye"/></button></router-link>
                                -->
                                <button type="button" class="btn btn-primary btn-normal" @click="updateInvestment(props.row)"><i class="mdi mdi-pencil"/></button>
                                <button v-if="false" type="button" class="btn btn-link" @click="deleteInvestment(props.row.id)"><i class="mdi mdi-delete"/></button></span>
                            </span>
        </template>
        <template v-slot:emptystate v-if="!isLoading">
          <div class="text-center">
            {{ t('investmentIndexTableComponent.no_records_found') }}
          </div>
        </template>
        <template v-slot:emptystate v-if="isLoading">
          <div class="text-center">
            {{ t('investmentIndexTableComponent.loading') }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
